/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const ShortcutTable = styled.table`
  color: var(--grey-darken-33);
  line-height: 1.618;
  font-size: 1em;
  font-weight: 400;
  display: table;
  width: 100%;
`;
